import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { pathConstants } from "../../../routes/pathContants";
import secondaryComponents from "../../../components/secondaryComponents";
import { useState } from "react";

export const SMEndOfDay = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const [props, setProps] = useState({
    headerTitle: "End of Day",
    headerDescription:
      "You can customize how you want to receive your end of day with the options below",
    hasPrevNavigation: false,
    routeToPrev: null,
  });

  return (
    <RoutedModal
      isActive={true}
      headerTitle={props?.headerTitle}
      headerDescription={props?.headerDescription}
      hasPrevNavigation={props?.hasPrevNavigation}
      routeToPrev={props?.routeToPrev}
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
      bodyStyle={{ paddingBottom: "0" }}
      style={{ paddingBottom: "0" }}
    >
      <secondaryComponents.SalesEndOfDay props={props} setProps={setProps} />
    </RoutedModal>
  );
};
